import * as React from "react";
import { InvalidLicenseWarning } from "license/LicenseCheck";
import SearchFilterPageSubactions from "search-filter/components/filter-management-pages/SearchFilterPageSubactions";
import UserSearchFilterDetails from "search-filter/components/filter-management-pages/UserSearchFilterDetails";
import { PageHeader, DocumentTitle, Spinner } from "components/common";
import DocsHelper from "util/DocsHelper";
import useSearchFilterLicenseStatus from "search-filter/hooks/useSearchFilterLicenseStatus";
const MyFiltersDetailsPage = () => {
  const { isFetchingLicense, isValidLicense } = useSearchFilterLicenseStatus();
  if (isFetchingLicense) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "View Filter Details" }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "View Filter Details",
      actions: /* @__PURE__ */ React.createElement(SearchFilterPageSubactions, null),
      documentationLink: {
        title: "Search filter documentation",
        path: DocsHelper.PAGES.SEARCH_FILTERS
      }
    },
    /* @__PURE__ */ React.createElement("span", null, "View search filter details and usages in searches and dashboards.")
  ), isValidLicense ? /* @__PURE__ */ React.createElement(UserSearchFilterDetails, null) : /* @__PURE__ */ React.createElement(
    InvalidLicenseWarning,
    {
      featureName: "search filter",
      licenseSubject: "/license/enterprise/search-filter",
      displayWarningContainer: true
    }
  ));
};
export default MyFiltersDetailsPage;
